import Heading from './Heading';

export * from './Heading';

export default Heading;
